import { MainData } from '@services/requests/companyProfileService/types/mainData';
import React from 'react';

import { BankDetailsModule } from '../../CompanyProfileModules/BankDetailsModule';
import { CompanyProfileModulesWrapper } from '../../CompanyProfileModulesWrapper';
import { MainTabStyledContainer } from './StyledComponents';

interface MainTabProps {
  mainData: MainData;
  isAllowEdit: boolean;
  isInspection: boolean;
  onChangeInspection: (value: boolean) => void;
}

function MainTab({ mainData, isInspection, isAllowEdit, onChangeInspection }: MainTabProps) {
  return (
    <MainTabStyledContainer>
      <div className="main-tab-column">
        <CompanyProfileModulesWrapper
          mainData={mainData}
          isAllowEdit={isAllowEdit}
          isInspection={isInspection}
          onChangeInspection={onChangeInspection}
        />
      </div>
      <div className="main-tab-column">
        <BankDetailsModule isAllowEdit={isAllowEdit} mainData={mainData} />
      </div>
    </MainTabStyledContainer>
  );
}

export { MainTab };
